import { getRequest } from "@/utils/http";

/**
 *
 * @param {*} params 文章的ID
 * @returns 文章详情信息
 */
export function getArticleDetailById(params) {
  return getRequest("/zplan/api/articleDetail", params);
}
